import React, { useEffect, useRef, useState } from "react";
import {
  Anchor,
  Box,
  Button,
  Center,
  Checkbox,
  createStyles,
  Grid,
  Group,
  Input,
  List,
  Loader,
  Radio,
  Select,
  Text,
  TextInput,
  ThemeIcon,
} from "@mantine/core";
import {
  createQtrResponse,
  extractQuestionnaireIds,
  extractQuestionnareResource,
  getCardsDetails,
  getGeneratedQuestions,
  getQuestionnaireResponse,
  matchQuestionsAndAnswers,
  startCall,
} from "./Service";
import { IconCircleCheck, IconGripVertical, IconPhone, IconWorld } from "@tabler/icons-react";
import ChatUI from "./ChatNew";
import { PatientDetails } from "./Card";
import { DateTimePicker } from "@mantine/dates";
import Logo from "../../assets/img/embedLogo.svg";
import { IconMail } from "@tabler/icons-react";
import { useParams } from "react-router-dom";
import FHIR from "fhirclient";
import { getPatientName } from "../Eligibility/EligibiltyService";
import BorderFrame from "../Embed/Border";
import { PatientNotFound } from "../Patient/PatientVisits/DataNotFound";
import { Questions } from "./Questions";
import { connectCommSocket, connectQnrResSocket } from "./CommunicationServices";
import { showNotification } from "@mantine/notifications";
import { Summary } from "../AIRecipes/SummaryAi";
import { MedplumClient } from "@medplum/core";
import { getConfig } from "../../config";

interface Details {
  form?: boolean;
  type?: 'chat' | 'qnr';
}

export const CategoryChat: React.FC<Details> = ({ form, type = 'chat' }) => {
  const useStyles = createStyles(() => ({
    mainBox: { width: "30%" },
    box1: { display: "flex", flexDirection: "column", gap: "16px", },
    box2: {
      gap: "8px",
      display: "flex",
      flexDirection: "column",
    },
    box3: {
      display: "flex",
      flexDirection: "column",
      border: "1px solid #EDEDED",
      borderRadius: "6px",
      gap: "12px",
      padding: "12px",
      overflowY: "auto",
      maxHeight: form ? "42vh" : "42vh",
      scrollBehavior: "smooth",
      "&::-webkit-scrollbar": {
        width: "1px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#555",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
    },
    box4: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      justifyContent: "flex-end",
    },
    box5: { display: "flex", flexDirection: "row", gap: "8px" },
    text: { fontWeight: 600, fontSize: "14px", lineHeight: "21px" },
    boxSelect: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      width: "100%",

    },
    boxSelect1: {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      gap: "6px",
    },
    card: {
      padding: "10px",
      borderRadius: "8px",
      backgroundColor: "transparent",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
    },
    dragIcon: {
      marginRight: "10px",
      color: "#757575",
      cursor: "grab",
      minWidth: "fit-content",
      alignItems: "center",
    },
    checkbox: {
      marginRight: "10px",
    },
    checkText: {
      flexGrow: 1,
    },

    firstBox: {
      borderRadius: "8px",
    },
    questionText: {
      fontWeight: 500,
      fontSize: "12px",
    },
    boxQuestion: {
      border: "1px solid #EDEDED",
      width: "100%",
      padding: "16px",
      borderRadius: "10px",
      gap: "8px",
      display: "flex",
      flexDirection: "column",
    },
    callBox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "55vh",
      gap: "10px",
      borderRadius: "8px",
      border: "1px solid #EDEDED ",
    },
    callText: {
      fontWeight: 500,
      fontSize: "14px",
      // lineHeight: "24px",
      color: "#242424",
    },
  }));
  type MappedIdsType = {
    [key: string]: string[];
  };
  interface AnswerState {
    [key: string]: string | boolean | Date | null;
  }

  const { classes } = useStyles();
  const config = getConfig();
  const medplum = new MedplumClient({
    baseUrl: config.baseUrl,
    cacheTime: 1000,
    autoBatchTime: 100,
  });
  const { code } = useParams();
  const patId = '07c81bc6-81f4-46b4-8e1d-20ff72ae244a';
  const [answers, setAnswers] = useState<AnswerState>({});
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [patient, setPatient] = useState<any>();
  const [showBorder, setShowBorder] = useState<boolean>(false);
  const [questionsText, setQuestionsText] = useState<any>([]);
  const [qnrName, setQnrName] = useState("");
  const [login, setLogin] = useState<boolean>(false);
  const [isLoading, setisLoading] = useState(false);
  const [cardDetails, setCardDetails] = useState<any>([]);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [checkBoxLabels, setCheckboxLabels] = useState<any>([]);
  const [draggingIndex, setDraggingIndex] = useState<number | null>(null);
  const [reorderedLinkIds, setReorderedLinkIds] = useState<string[]>([]);
  const [checkedArray, setCheckedArray] = useState<any>([]);
  const [filteredIds, setFilteredIds] = useState<any>([]);
  const [callStarted, setCallStarted] = useState<boolean>(false);
  const [isCallLoading, setIsCallLoading] = useState<boolean>(false);
  const [phnNo, setPhnNo] = useState<any>();
  const [matchedQ, setMatchedQ] = useState<any>();
  const [qRes, setQRes] = useState<any>();
  const [messages, setMessages] = useState<any>([]);
  const [qnr, setQnr] = useState<any>();

  const commWS = useRef<WebSocket | null>(null);
  const ws = useRef<WebSocket | null>(null);

  const cardDetailss = [
    {
      label: "Medication Adherence Support",
      value: "1",
    },
    {
      label: "Telehealth Visit Preparation",
      value: "2",
    },
    {
      label: "Annual Health Check-Up Reminders",
      value: "3",
    },
    {
      label: "Pre-Appointment Insurance Verification",
      value: "4",
    },
    {
      label: "Remote Patient Monitoring (RPM) Check-Ins",
      value: "5",
    },
    {
      label: "Automated Confirmation Calls",
      value: "6",
    },
    {
      label: "Post-Discharge Follow-Up",
      value: "7",
    },
    {
      label: "Hospital Discharge Planning",
      value: "8",
    },
  ];

  useEffect(() => {
    if (login === true) {
      getQuestions();
    }
  }, [checkBoxLabels]);

  useEffect(() => {
    const linqId = compareArrays(reorderedLinkIds);
    setFilteredIds(linqId);
  }, [checkedArray, reorderedLinkIds]);

  useEffect(() => {
    loginWithIdandSecret();
    if (login === true) {
      fetchData();
      questionnaireResponse();
    }
  }, [login]);

  useEffect(() => {
    if (matchedQ?.length > 0 && qnr.length > 0) {
      setMatchedQ(matchQuestionsAndAnswers(getCardsDetails(qnr, qRes)[0]));
    }
  }, [qRes]);

  useEffect(() => {
    // Filter questions based on checked items
    const filteredQuestions = questionsText?.filter((item: any) =>
      checkedArray?.includes(item?.linkId)
    );

    // Check if all filtered questions are filled
    const allFilled = filteredQuestions?.every(
      (item: any) =>
        answers[item?.linkId] !== undefined &&
        answers[item?.linkId] !== null &&
        answers[item?.linkId]
    );

    // Disable or enable the submit button based on whether all questions are filled
    if (!allFilled) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  }, [checkedArray, answers, questionsText]); // Dependency array updated

  const questionnaireResponse = async () => {
    // const res = await extractQuestionnare(medplum, 20, 1);
    // const mapped = mapQuestionnaireToCardDetails(res, cardDetailss, true);
    const mapped = cardDetailss.map(item => {
      return {
        value: item.value,
        label: item.label
      }
    })
    setCheckboxLabels(mapped?.[0]?.value);
    setCardDetails(mapped);
    return mapped;
  };
  const loginWithIdandSecret = async () => {
    try {
      const decodedQuery = decodeURIComponent(code as string);

      const decodeQueryStringWithData = atob(decodedQuery);

      const queryParamss = decodeQueryStringWithData.split(",");
      const id = queryParamss[0];
      const secret = queryParamss[1];

      const login = await medplum.startClientLogin(id, secret);
      if (login) {
        setLogin(true);
        return true;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchData = async () => {
    try {
      const client = await FHIR.oauth2.ready();

      // Get the patient data
      const patientData = await client.patient.read<any>();

      setPatient(patientData);
    } catch (error) {
      console.error(error);
    }
  };

  const getQuestions = async () => {
 
    const categoryName = cardDetailss.find((item) => item.value === checkBoxLabels)?.label
    getGeneratedQuestions(medplum, patId, categoryName ?? '').then(async (res) => {
      setQnrName(categoryName ?? '')
      if (!res) return
      setQuestionsText(res)
      const linkIds = res.map((item: any) => item.linkId);
      setReorderedLinkIds(linkIds);
      setCheckedArray(linkIds);
      setisLoading(false);
      setIsSubmitDisabled(true)
      
    })
  };

  const handleDragStart = (index: number) => {
    setDraggingIndex(index);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleDrop = (index: number) => {
    if (draggingIndex === null) return;

    const reorderedItems = [...questionsText];
    const [draggedItem] = reorderedItems.splice(draggingIndex, 1);
    reorderedItems.splice(index, 0, draggedItem);

    setQuestionsText(reorderedItems);

    const reorderedIds = reorderedItems.map((item) => item.linkId);
    setReorderedLinkIds(reorderedIds);

    setDraggingIndex(null);
  };

  const compareArrays = (otherArray: any[]) => {
    const result = [];
    for (const element of otherArray) {
      if (checkedArray.includes(element)) {
        result.push(element);
      }
    }
    return result;
  };

  const handleAnswerChange = (
    linkId: string,
    value: string | boolean | Date | null
  ) => {
    setAnswers((prev) => ({
      ...prev,
      [linkId]: value,
    }));
  };

  const handleSubmit = async () => {
    setIsSubmitted(true);
    setIsSubmitDisabled(true);
    const questionnaireResponse = {
      resourceType: "QuestionnaireResponse",
      status: "completed",
      item: questionsText.map((item: any) => {
        const answer = answers[item.linkId];
        let answerObj: any = {};

        switch (item.type) {
          case "string":
            answerObj = { valueString: answer };
            break;
          case "boolean":
            answerObj = { valueBoolean: answer };
            break;
          case "dateTime":
            answerObj = { valueDateTime: (answer as Date)?.toISOString() };
            break;
          case "choice":
            answerObj = { valueString: answer };
            break;
          default:
            break;
        }

        return {
          id: `id-${item.linkId}`,
          linkId: item.linkId,
          text: item.text,
          answer: [answerObj],
        };
      }),
      questionnaire: `Questionnaire/${checkBoxLabels}`,
      source: {
        reference: `Patient/07c81bc6-81f4-46b4-8e1d-20ff72ae244a`,
        display: "test User",
      },
      authored: new Date().toISOString(),
    };

    const response = await createQtrResponse(medplum, questionnaireResponse);
  };
  const handleChange = (event: any) => {
    setShowBorder(event.currentTarget.checked);
  };



  const handleStart = async () => {

    if (!phnNo) {
      showNotification({ color: 'orange', message: "Phone No. cannot be empty", autoClose: true });
      return;
    }

    if (phnNo?.length < 11) {
      showNotification({ color: 'orange', message: "Please Include Your Country Code.", autoClose: true });
      return;
    }

    setIsCallLoading(true);
    const patRes = await medplum.readResource('Patient', patId);
    patRes.name = patient.name;
    medplum.updateResource(patRes);
    const categoryName = cardDetailss.find((item) => item.value === checkBoxLabels)?.label
    const callOb = await startCall(
      medplum,
      patId, //Hardcoded for now
      'e8983eb0-c0e0-4d00-8cde-e4b8160e67ff', //qnrId is not needed while passing questionsText, however its expected, so using a dummy value
      phnNo,
      filteredIds,
      questionsText,
      categoryName ?? "",
    );

    const qRes = await getQuestionnaireResponse(medplum, 1, 1, [
      `Patient/${patId}`,
    ])

    const questionnaireIds = extractQuestionnaireIds(qRes as any);
    const qnr = await extractQuestionnareResource(medplum, 1, 1, questionnaireIds)

    const formattedQnrData = getCardsDetails(qnr, qRes);
    const matchedQuestions = matchQuestionsAndAnswers(formattedQnrData[0]);

    setQnr(qnr);
    setQRes(qRes);
    setMatchedQ(matchedQuestions);

    if (callOb?.socket?.qnrResToken)
      connectQnrResSocket(
        ws,
        setQRes,
        callOb?.socket?.qnrResToken
      );
    if (callOb?.socket?.commToken)
      connectCommSocket(commWS, setMessages, callOb?.socket?.commToken, matchedQuestions);

    setCallStarted(true);
    setIsCallLoading(false);

  }
  return (
    <BorderFrame showBorder={showBorder}>
      <Box
        className={classes.firstBox}
        sx={{ height: showBorder ? "100vh" : "100%" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: showBorder ? "space-between" : "",
            gap: "10px",
            height: "100%",
            backgroundColor: "#F8F8F8",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              backgroundColor: "#F8F8F8",
            }}
          >
            <Box className={classes.mainBox} sx={{ backgroundColor: 'white' }}>
              {isLoading ? (
                <Center mih="400px">
                  <Loader variant="dots" />
                </Center>
              ) : (
                <Box className={classes.box1} sx={{ backgroundColor: "white" }}>
                  <Box
                    className={classes.boxSelect1}
                    sx={{ backgroundColor: "red" }}
                  >
                    <Box
                      className={classes.boxSelect}
                      sx={{ backgroundColor: "white" }}
                    >
                      <Box
                        mb={15}
                        sx={{
                          display: "flex",
                          backgroundColor: "#F1F9FF",
                          height: "105px",
                          justifyContent: "center",
                          alignItems: "center",
                          borderBottom: "1px solid #BEDEF8",
                        }}
                      >
                        <img
                          src={Logo}
                          style={{ height: "177", width: "40" }}
                        />
                      </Box>

                      <Text pr={"8px"} pl={"8px"} className={classes.text}>
                        Select Questionnaire
                      </Text>
                      <Select
                        pl={"8px"}
                        pr={"8px"}
                        data={cardDetailss}
                        // placeholder={qnrName}
                        radius="md"
                        size="md"
                        value={checkBoxLabels}
                        disabled={callStarted || isCallLoading}
                        onChange={(e: any) => {
                          setAnswers({});
                          setCheckboxLabels(e);
                          setQuestionsText([]);
                          setIsSubmitted(false);
                          setIsSubmitDisabled(false);
                        }}
                      />
                    </Box>
                  </Box>

                  <Box
                    className={classes.box2}
                    sx={{ backgroundColor: "white" }}
                    pl={"8px"}
                    pr={"8px"}
                  >
                    <Text className={classes.text}>Questions</Text>
                    {questionsText?.length > 0 ? (
                      <Box className={classes.box3}>
                        {questionsText.map((item: any, index: any) => (
                          <div
                            key={item?.linkId}
                            draggable={!(callStarted || isCallLoading)}
                            onDragStart={() => handleDragStart(index)}
                            onDragOver={handleDragOver}
                            className={classes.card}
                            onDrop={() => handleDrop(index)}
                          >
                            <IconGripVertical className={classes.dragIcon} />
                            <Checkbox
                              checked={checkedArray.includes(item.linkId)}
                              // label={item?.text}
                              className={classes.checkbox}
                              disabled={callStarted || isCallLoading}
                              size="sm"
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                const itemId = item.linkId;
                                if (isChecked) {
                                  setCheckedArray((prevArray: any) => [
                                    ...prevArray,
                                    itemId,
                                  ]);
                                } else {
                                  setCheckedArray((prevArray: any) =>
                                    prevArray.filter((id: any) => id !== itemId)
                                  );
                                }
                              }}
                            />
                            <Text sx={{ fontSize: "11px" }}> {item?.text}</Text>
                            {/* {item?.text} */}
                          </div>
                        ))}
                      </Box>
                    ) : (
                      
                        <Box><Center mih="400px">
                          <Loader variant="dots" />
                        </Center>
                          <Center sx={{  maxWidth: "80%" }}><Summary
                            text={'Generating Questions...'}
                            title=""

                          /></Center></Box>)}
                    
                  </Box>
                  <Box sx={{ backgroundColor: "white", height: "100%" }}>
                    <Checkbox
                      size={"xs"}
                      pl={"8px"}
                      pr={"8px"}
                      pt={"8px"}
                      mb={"8px"}
                      checked={showBorder}
                      label="Simulate launch without the EHR UI (launch without an iFrame)"
                      onChange={handleChange}
                    />
                  </Box>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "100%",
                // padding: "2px",
              }}
            >
              <Box pt={0} sx={{ backgroundColor: "white" }}>
                <PatientDetails
                  name={getPatientName(patient?.name)}
                  dob={patient?.birthDate ?? "--"}
                  mobile={patient?.telecom?.[0]?.value}
                  address={"--"}
                  email={patient?.email ?? "--"}
                  gender={patient?.gender ?? "--"}
                  moreDetails={true}
                  city={patient?.address?.[0]?.city}
                  country={patient?.address?.[0]?.country}
                  age={
                    patient?.birthDate
                      ? new Date().getFullYear() -
                      new Date(patient.birthDate).getFullYear() -
                      (new Date().setFullYear(0) <
                        new Date(patient.birthDate).setFullYear(0)
                        ? 1
                        : 0)
                      : "--"
                  }
                />
              </Box>
              <Box sx={{ display: "flex", height: "100%" }}>
                {form ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      width: "100%",
                    }}
                  >
                    {" "}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        height: showBorder ? "58vh" : "57vh",
                        overflowY: "auto",

                        scrollBehavior: "smooth",
                        "&::-webkit-scrollbar": {
                          width: "1px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#888",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          backgroundColor: "#555",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                      }}
                    >
                      {checkedArray.length === 0 && (
                        <>
                          <Box h={"100%"} sx={{ backgroundColor: "white" }}>
                            {isLoading ? (
                              <Center
                                h={"100%"}
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                {" "}
                                <Loader />
                              </Center>
                            ) : (
                              <PatientNotFound patient="Questions" />
                            )}
                          </Box>
                        </>
                      )}
                      {questionsText
                        ?.filter((item: any) =>
                          checkedArray.includes(item.linkId)
                        ) // Filter based on checked array
                        .map((item: any) => {
                          return (
                            <Box
                              pr={"8px"}
                              key={item.linkId}
                              mb="sm"
                              className={classes.boxQuestion}
                              sx={{ backgroundColor: 'white' }}
                            >
                              <Text mb="xs" className={classes.questionText}>
                                {item?.linkId}: {item?.text}
                              </Text>
                              {item?.type === "string" && (
                                <TextInput
                                  placeholder="Type your answer..."
                                  size="sm"
                                  radius={"sm"}
                                  onChange={(e) =>
                                    handleAnswerChange(
                                      item.linkId,
                                      e.currentTarget.value
                                    )
                                  }
                                  value={
                                    answers[item?.linkId]
                                      ? (answers[item?.linkId] as string)
                                      : ("" as string)
                                  }
                                  disabled={isSubmitted}
                                />
                              )}
                              {item?.type === "choice" &&
                                item?.answerOption && (
                                  <Radio.Group
                                    size="sm"
                                    onChange={(value) =>
                                      handleAnswerChange(item?.linkId, value)
                                    }
                                    value={
                                      answers[item?.linkId]
                                        ? (answers[item?.linkId] as string)
                                        : ("" as string)
                                    }
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: "16px",
                                      }}
                                    >
                                      {item?.answerOption.map(
                                        (option: any, index: any) => (
                                          <Radio
                                            size="'sm"
                                            key={index}
                                            value={option?.valueString}
                                            label={option?.valueString}
                                            disabled={isSubmitted}
                                            sx={{ fontSize: "12px" }}
                                          />
                                        )
                                      )}
                                    </Box>
                                  </Radio.Group>
                                )}
                              {item?.type === "boolean" && (
                                <Checkbox
                                  size={'sm'}
                                  label="Yes"
                                  checked={answers[item?.linkId] as boolean}
                                  onChange={(e) =>
                                    handleAnswerChange(
                                      item?.linkId,
                                      e.currentTarget.checked
                                    )
                                  }
                                  disabled={isSubmitted}
                                  sx={{ fontSize: "12px" }}
                                />
                              )}
                              {item?.type === "dateTime" && (
                                <Box sx={{ width: "100%" }}>
                                  <DateTimePicker
                                    size="sm"
                                    radius={"sm"}
                                    clearable
                                    label="Pick date and time"
                                    placeholder="Pick date and time"
                                    maw={"100%"}
                                    mx="auto"
                                    sx={{ fontSize: "12px" }}
                                    value={answers?.[item?.linkId] as Date}
                                    onChange={(value) =>
                                      handleAnswerChange(item?.linkId, value)
                                    }
                                    disabled={isSubmitted}
                                  />
                                </Box>
                              )}
                            </Box>
                          );
                        })}
                    </Box>
                    {checkedArray.length > 0 && (
                      <Box
                        pr={"8px"}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          disabled={isSubmitDisabled}
                          pr={20}
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                      </Box>
                    )}
                  </Box>
                ) : (
                  <Box mih={"100%"} w={"100%"}>
                    {checkedArray.length === 0 ? (
                      <>
                        <Box h={"100%"} w={"100%"}>
                          {isLoading ? (
                            <Center
                              h={"60vh"}
                              sx={{ display: "flex", alignItems: "center" }}
                            >
                              {" "}
                              <Loader />
                            </Center>
                          ) : (
                            <Box h={"60vh"}>
                              <PatientNotFound patient="Questions" />
                            </Box>
                          )}
                        </Box>
                      </>
                    ) : (
                      <Box p={"8px"} sx={{ backgroundColor: "white" }}>
                        {isCallLoading && <Center display={'flex'} pos={"relative"} top={'30ch'}><Loader /></Center>}
                        {type === "chat"
                          ? <ChatUI
                            patientName={"John Doe"}
                            mobile={"9521424543"}
                            dob={"12/12/2004"}
                            linkedIds={filteredIds}
                            qtrId={checkBoxLabels}
                            questionText={questionsText}
                            patientId={"07c81bc6-81f4-46b4-8e1d-20ff72ae244a"}
                            // qtrResponseIdForChat={qtrResponseId ?? ""}
                            launchType={"qnr"}
                            embed={true}
                          />
                          : <Box h={'60vh'} p={20}>
                            {callStarted
                              ?
                              <Questions
                                launchType="embed"
                                questions={matchedQ}
                                questionnareResponseId={qRes[0]?.id}
                                patientName={getPatientName(patient?.name)}
                                messages={messages}
                                setMessages={setMessages}
                                handleRetry={() => { }}
                              />
                              : !isCallLoading && <Box className={classes.callBox}>
                                <Text size={18} weight={600} mb={5} color="#333333" pb={5} align="center">
                                  Automated Questionnaire System
                                </Text>
                                <List withPadding size="sm" spacing="xs"
                                  icon={
                                    <ThemeIcon color="teal" size={16} radius="xl">
                                      <IconCircleCheck style={{ width: 16, height: 16 }} />
                                    </ThemeIcon>
                                  }>
                                  <List.Item>
                                    <Text className={classes.callText}>This feature provides an automated system for completing medical <code style={{ color: "#1B75BC" }}>Questionnaires</code>.</Text>
                                  </List.Item>
                                  <List.Item>
                                    <Text className={classes.callText}>The call is handled by our <code style={{ color: "#1B75BC" }}>QConnect AI</code> Bot, and we use FHIR <code style={{ color: "teal" }}>QuestionnaireResponse</code> to store all the answers.</Text>
                                  </List.Item>
                                  <List.Item>
                                    <Text className={classes.callText}>For demonstration purposes, you can call your own number.</Text>
                                  </List.Item>
                                  <List.Item>
                                    <Text className={classes.callText}>
                                      Once you start the call, you will be taken to the call display screen, featuring <code style={{ color: "#F59E0B" }}>real-time</code> summary and transcription.
                                    </Text >
                                  </List.Item>
                                </List>
                                <Grid ml={"50%"} miw={"100%"} mt={20}>
                                  <Grid.Col md={6} lg={6}>

                                    <Text size={14} weight={600} mb={5} color="#333333" pb={5} align="center">
                                      Please enter patient's phone number
                                    </Text>
                                    <Input<any>

                                      required={true}
                                      // error={error?.npi}m
                                      value={phnNo}
                                      validation={(val: any) => val.length > 0}
                                      onChange={(e: any) => setPhnNo(e.target.value)}
                                      onKeyDown={(evt: any) => ["e", "E", , "-"].includes(evt.key) && evt.preventDefault()}
                                      placeholder="Enter Phone Number" />
                                    {/* {error?.npi && <Text color="red">{error?.npi}</Text>} */}
                                  </Grid.Col  >
                                </Grid>
                                <Button miw={"20%"}
                                  onClick={() => handleStart()}
                                > <IconPhone size={20} style={{ marginRight: '5px' }} /> Start Call</Button>

                              </Box>}
                          </Box>}
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
          {/* footer part */}
          <Box
            style={{
              padding: "1rem 0",
              borderTop: "1px solid #eaeaea",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-evenly",
              backgroundColor: "rgb(243 250 255)",
            }}
          >
            <Group spacing="xs">
              <IconMail color="#228be6" size={20} />
              <Text size="sm" color="blue">
                <Anchor
                  href="mailto:healthconnect@mindbowser.com"
                  target="_blank"
                >
                  healthconnect@mindbowser.com
                </Anchor>
              </Text>
            </Group>

            <Group spacing="xs">
              <IconWorld color="#228be6" size={20} />
              <Text
                sx={{
                  cursor: "pointer",
                  textDecoration: "none", // No underline by default
                  "&:hover": {
                    textDecoration: "underline", // Underline on hover
                  },
                }}
                size="sm"
                color="blue"
                onClick={() =>
                  window.open("https://healthconnect.mindbowser.com/")
                }
              >
                healthconnect.mindbowser.com
              </Text>
            </Group>

            <Text size="sm" color="blue">
              © 2024 Mindbowser Inc. All rights reserved.
            </Text>
          </Box>
        </Box>
      </Box>
    </BorderFrame>
  );
};
